import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';

export const CostoEnvioService = {
	Listar: () => {
		let params = {};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Costo_Envio_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let params = {
			id_cat_costo_mensajeria: null,
			id_cat_tipo_mensajeria: form.id_cat_tipo_mensajeria,
			cantidad_pares_fin: form.cantidad_pares_fin,
			cantidad_pares_inicio: form.cantidad_pares_inicio,
			costo: form.costo,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Costo_Envio_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			id_cat_costo_mensajeria: form.id_cat_costo_mensajeria,
			id_cat_tipo_mensajeria: form.id_cat_tipo_mensajeria,
			cantidad_pares_fin: form.cantidad_pares_fin,
			cantidad_pares_inicio: form.cantidad_pares_inicio,
			costo: form.costo,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Costo_Envio_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_cat_costo_mensajeria) => {
		let params = {
			id_cat_costo_mensajeria: id_cat_costo_mensajeria
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Costo_Envio_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
